import React from 'react';
import classnames from 'classnames';
import styles from './endpoint-styles.module.scss';
import {IconButton} from '@mui/material';
import InfoTooltip from '../../../../../shared/components/info-tooltip';
import Icon from 'shared/components/icon';
import {useDispatch} from 'react-redux';
import {flashMessage} from '../../../../../shared/actions/notifications';

interface Props {
  isEdit: boolean;
  generatedPassword: string;
  formPassword: string;
}

const tooltipText =
  'Passwords for existing endpoints cannot be viewed after creation, if you need a password for this endpoint, generate a new one.';

export const PasswordDisplay = ({isEdit, generatedPassword, formPassword}: Props) => {
  const dispatch = useDispatch();

  const copyIcon = (pw: string) => (
    <span className={classnames('mb-4', styles.alignCenter)}>
      <IconButton
        onClick={async () => {
          await navigator.clipboard.writeText(pw);
          dispatch(flashMessage('Link copied to clipboard!', 'success', {}, 2000));
        }}
      >
        <Icon iconType="copy-r" className={classnames(styles.copyIcon)} />
      </IconButton>
    </span>
  );

  if (isEdit) {
    if (generatedPassword) {
      return (
        <>
          <p className="alert alert-danger">Save to apply the new password.</p>
          <div className={styles.flexDiv}>
            <p className="shared-font body mt-4 mr-8">{generatedPassword}</p>
            {copyIcon(generatedPassword)}
          </div>
        </>
      );
    }
    return (
      <div className={styles.flexDiv}>
        <p className={classnames(styles.marginTopSix, 'shared-font body mr-4')}>****************</p>
        <InfoTooltip>{tooltipText}</InfoTooltip>
      </div>
    );
  }
  if (formPassword) {
    return (
      <div className={styles.flexDiv}>
        <p className="shared-font body mt-4 mr-8">{formPassword}</p>
        {copyIcon(formPassword)}
      </div>
    );
  }
  return <p className="alert alert-warning">No password has been generated</p>;
};
